import { render, staticRenderFns } from "./totalGuestSavings.vue?vue&type=template&id=5a786c84"
import script from "./totalGuestSavings.js?vue&type=script&lang=js&external"
export * from "./totalGuestSavings.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports